import { IShopItem } from '~/src/api/content/shop/getShopItems';

// @deprecated use @r1-frontend/shared/types
export interface IProductPrice {
    duration: number | null,
    value: number,
    type: 1 | 5,
    sort: number | null,
}

// @deprecated use @r1-frontend/shared/types
interface IProductTv {
    id: number,
    city_id: number,
    billing_city_id: number,
    materials_ens_id: number,
    mat_name: string,
    posess_price: number,
    leasing_mon_price: number,
    rent_price: number | null,
    leasing_dur: number,
    leasing_mon_price_two: number,
    leasing_dur_two: number,
    alias: string | null,
    description: string,
    description_main: string,
    image: string,
    available_site: 1 | 0,
    available_mobile: 1 | 0,
    label: string,
    youtube: string,
    url: string,
    additional_condition: string,
    image_for_tariff_card: string,
    image_for_tariff_card_height: number,
    image_for_tariff_card_width: number,
    imageFull: string,
    imageCardFull: string,
    prices: IProductPrice[],
    urls: unknown[],
}

interface IProductRouter {
    additionalImages: string[],
    alias?: string,
    color: string,
    cubeEquipment: null,
    description: string,
    equipmentCount: number,
    image_for_tariff_card: null,
    image_for_tariff_card_height: null,
    image_for_tariff_card_width: null,
    isGigabit: 0 | 1,
    labelName: string,
    leasingDuration: number,
    leasingDurationSec: number,
    leasingPrice: number,
    leasingPriceSec: number,
    mainImage: string,
    image: string,
    materialsEnsId: number,
    materialsEnsName: string,
    posessPrice: number,
    prices: IProductPrice[],
    properties: unknown,
    routerSquare: number,
    router_groups: null,
    sort: number,
    sortWeight: number,
    speed: number,
    url: string,
    urls: unknown[],
}

// @deprecated use @r1-frontend/shared/types TAdditional
export interface IAdditional {
    id: number,
    tariff_type: string,
    product_id: number,
    product_type: string,
    required: 1 | 0,
    leasing_duration: number,
    description: unknown,
    manual: 1 | 0,
    billing_city_id: number,
    is_visible: 1 | 0,
    name: unknown,
    shopItem: IShopItem,
    price: number,
    base_price: number | null,
    first_month_price: number | null,
}

// @deprecated use @r1-frontend/shared/types
export enum EProductTypeStr {
    TV = 'tv',
    ROUTER = 'router',
}

// @deprecated use @r1-frontend/shared/types
export interface IAdditionalProductTv extends IAdditional {
    product_type: EProductTypeStr.TV,
    product: IProductTv,
}

// @deprecated use @r1-frontend/shared/types
export interface IAdditionalProductRouter extends IAdditional {
    product_type: EProductTypeStr.ROUTER,
    product: IProductRouter,
}

export type TAdditionalProduct = IAdditionalProductTv | IAdditionalProductRouter;
